import * as ActionTypes from "./ActionTypes";
import axios from "axios";

export const setInformations = info => {
	return {
		type: ActionTypes.LOAD_INFORMATIONS,
		informations: info.data
	};
};
/*
export const onUpdateInformativeText = response => {
	return {
		type: ActionTypes.MODIFY_INFORMATIVETEXT,
		response: response
	};
};
*/

export const loadInformations = () => {
	return dispatch => {
		axios
			.get("http://190.105.227.203/solanasapi/informacion")
			.then(response => {
				dispatch(setInformations(response.data));
			})
			.catch(error => {});
	};
};

export const saveInformation = (information, token) => {
	return dispatch => {
		const AuthStr = "Bearer ".concat(token);
		axios
			.post(
				"https://getupstudio.co/solanasapi/informacion/",
				information,
				{
					headers: { Authorization: AuthStr }
				}
			)
			.then(response => {
				dispatch(loadInformations());
			})
			.catch(error => {});
	};
};
